import { createAction, createAsyncAction } from "typesafe-actions";

import type { SearchQuotaDto } from "app/pages/sales-intelligence/modules/leads-search";
import type { FetchError } from "app/pages/sales-intelligence/types";

import type { SaveSearchModalPayload } from "../types/common";
import type { SavedSearchDto, SimplifiedSavedSearchDto } from "../types/dto";

// Filters panel
export const toggleFiltersPanelAction = createAction("@@si/advanced-search-filters/panel-expand-toggled")();

// Modals
export const clearFiltersModalToggledAction = createAction(
    "@@si/advanced-search-filters/clear-modal-toggled",
)<boolean>();
export const saveSearchModalToggledAction = createAction("@@si/advanced-search-filters/save-search-modal-toggled")<
    Pick<SaveSearchModalPayload, "isOpen"> & Partial<SaveSearchModalPayload>
>();

export const deleteSavedSearchModalToggledAction = createAction(
    "@@si/advanced-search-filters/delete-saved-search-modal-toggled",
)<SimplifiedSavedSearchDto | SavedSearchDto | null>();
export const saveSearchTriggerModalToggledAction = createAction(
    "@@si/advanced-search-filters/save-search-trigger-modal-toggled",
)<boolean>();

export const saveNewSearchAsync = createAsyncAction(
    "@@si/advanced-search-filters/saving-search-started",
    "@@si/advanced-search-filters/saving-search-succeeded",
    "@@si/advanced-search-filters/saving-search-failed",
)<void, SavedSearchDto, FetchError>();

export const updateSavedSearchNameAsync = createAsyncAction(
    "@@si/advanced-search-filters/updating-search-name-started",
    "@@si/advanced-search-filters/updating-search-name-succeeded",
    "@@si/advanced-search-filters/updating-search-name-failed",
)<void, Pick<SavedSearchDto, "searchId" | "name">, FetchError>();

export const deleteSavedSearchAsync = createAsyncAction(
    "@@si/advanced-search-filters/deleting-search-started",
    "@@si/advanced-search-filters/deleting-search-succeeded",
    "@@si/advanced-search-filters/deleting-search-failed",
)<void, SavedSearchDto["searchId"], FetchError>();

export const fetchSearchQuota = createAsyncAction(
    "@@si/advanced-search-filters/FETCH_SEARCH_QUOTA_START",
    "@@si/advanced-search-filters/FETCH_SEARCH_QUOTA_SUCCESS",
    "@@si/advanced-search-filters/FETCH_SEARCH_QUOTA_FAILURE",
)<void, SearchQuotaDto, FetchError>();
